import { ContentArea } from '@/layout/components/content-area/ContentArea'
import { ContentGrid } from '@/layout/components/content-layout/ContentLayout.styled'
import { useHideNativeNavigation } from '@/layout/providers/LayoutProvider'
import { NotificationCenterPage } from '../notification-center/NotificationCenter.page'

const NotificationRoot = () => {
  useHideNativeNavigation()

  return (
    <ContentGrid>
      <ContentArea gridArea='content'>
        <NotificationCenterPage />
      </ContentArea>
    </ContentGrid>
  )
}

export { NotificationRoot }
